import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const toArray = (str) => {
  if (!str) return [];
  try {
    return JSON.parse(str)
  } catch (e) {
    console.log(e);
  }
  return [];
};
export default new Vuex.Store({
  state:{
    token: sessionStorage.token,
    userId: sessionStorage.userId,
    userName: sessionStorage.userName,
    account: sessionStorage.account,
    phone:sessionStorage.phone,
    lang:sessionStorage.lang,
    ReportData:toArray(sessionStorage.ReportData),
  },
  mutations:{
    setToken: (state, data) => {
      sessionStorage.token = data;
      state.token = data;
    },
    setUserId(state,data){
      sessionStorage.userId = data
      state.userId=data;
    },
    setUserName:(state,data)=>{
      sessionStorage.userName = data;
      state.userName = data;
    },
    setChineseOrEnglisg:(state,data)=>{
      sessionStorage.chineseOrEnglish=data;
      state.chineseOrEnglish=data;
    },
    setPhone:(state,data)=>{
      sessionStorage.phone=data;
      state.phone=data;
    },
    setAccount:(state,data)=>{
      sessionStorage.account=data;
      state.account=data;
    },
    setlang:(state,data)=>{
      sessionStorage.lang=data;
      state.lang=data;
    },
    setReportData:(state,data)=>{
      state.ReportData=data;
      sessionStorage.ReportData=JSON.stringify(data);
    }
  },
  actions:{}
})



// WEBPACK FOOTER //
// ./src/store/store.js